import { AxiosResponse } from 'axios';

import { ApiResponse } from '../api/api';
import { setModalVisible } from '../bound/RecaptchaModal';
import {
    RecaptchaActions,
    RECAPTCHA_KEY,
    RECAPTCHA_KEY_V2,
} from '../constants/recaptcha';
import { appendElement } from './dom';
import { getSessionParam, saveSessionParameters } from './storage';

export const getRecaptchaToken = (action: RecaptchaActions): Promise<string> =>
    new Promise((response, reject) => {
        try {
            window.grecaptcha.ready(() => {
                window.grecaptcha
                    .execute(RECAPTCHA_KEY, {
                        action: action,
                    })
                    .then(
                        token => response(token),
                        error => reject(error)
                    );
            });
        } catch (e) {
            if (!(e instanceof TypeError)) throw e;
        }
    });

class RecaptchaError extends Error {
    constructor() {
        super('Recaptcha library error');
        this.name = 'RecaptchaError';
    }
}

export const getRecaptchav2Token = (): Promise<string> =>
    new Promise(resolve => {
        try {
            window.grecaptcha.ready(() => {
                window.grecaptcha.render(
                    getRecaptchaContainer('recaptchaModal'),
                    {
                        sitekey: RECAPTCHA_KEY_V2,
                        callback: token => {
                            resolve(token);
                            hideRecaptcha();
                        },
                        'error-callback': function () {
                            throw new RecaptchaError();
                        },
                    }
                );
            });
        } catch (e) {
            if (!(e instanceof TypeError)) throw e;
        }
    });

export const getBypassToken = (): string | null => {
    return getSessionParam('recaptchaToken') || null;
};

export const saveBypassToken = (
    response: AxiosResponse<ApiResponse>
): AxiosResponse<ApiResponse> => {
    if (response.data.bypassRecaptchaTokenV2) {
        saveSessionParameters(
            'recaptchaToken',
            response.data.bypassRecaptchaTokenV2
        );
    }
    return response;
};

export const hideRecaptcha = (): void => {
    setModalVisible?.(false);
    try {
        window.grecaptcha.reset();
    } catch (e) {
        if (!(e instanceof TypeError)) throw e;
    }
    const element = document.getElementById('recaptcha') as HTMLElement;
    element?.remove();
};

export const getRecaptchaContainer = (elementId: string): HTMLElement => {
    setModalVisible?.(true);
    const e =
        (document.getElementById('recaptcha') as HTMLElement) ||
        appendElement('div', { id: 'recaptcha' }, elementId);
    return e;
};
